<div class="d-flex">
    <button *ngIf="showSubmit$ | async"
            [disabled]="!(canSubmit$ | async) || (isLoading$ | async)"
            class="mr-4"
            mat-stroked-button
            type="button"
            (click)="submitClick()"
    >
        <mat-icon class="mr-2 alert-success-foreground">send</mat-icon>
        Submit Completed Case
    </button>
    <button [disabled]="!(canSave$ | async) || (isLoading$ | async)"
            (click)="saveClick()"
            mat-stroked-button
            type="button">
        <mat-icon class="mr-2" color="primary">save</mat-icon>
        Save Case
    </button>
</div>
